import React from "react";

export default props => (
    <svg viewBox="0 0 14 11" {...props}>
        <g fill="none" fillRule="evenodd" stroke="#5C6977" strokeLinecap="round" strokeWidth="1.3">
            <path d="M2 1.5h10M2 6.833h10M2 4.167h10M2 9.5h10" />
        </g>
    </svg>
);
